<template>
  <div class="points-index">
    <LoadingModal />
    <!-- Header -->
    <van-nav-bar left-arrow title="微信零钱" left-text="返回" @click-left="onClickLeft" />
    <!-- 积分卡券头部 -->
    <div class="points-card">
      <div class="card-bg"></div>
      <div class="card-content">
        <div class="card-header">
          <span class="tag">{{ coupon.couponsMouldShowName }}</span>
        </div>
        <div class="points-amount">
          <span class="amount">{{ coupon.couponsBalance }}</span>
          <!-- <span class="unit">分</span> -->
        </div>
        <div class="card-info">
          <div class="info-item">
            <i class="iconfont icon-money"></i>
            <span>面额 {{ coupon.couponsDeno }}</span>
          </div>
          <div class="info-item">
            <i class="iconfont icon-calendar"></i>
            <span>有效期 {{ coupon.couponsEndDate }}</span>
          </div>
          <!-- <div class="info-item">
            <i class="iconfont icon-clock"></i>
            <span>{{ coupon.daysRemaining }} 天后到期</span>
          </div> -->
        </div>
      </div>
    </div>

    <div class="max-limit-tip">
      <i class="iconfont icon-warning"></i>
      <div>- 每日兑换限额{{claimSituation.dailyLimit}}元；每月兑换限额{{claimSituation.monthlyLimit}}元；</div>
      <div>- 单次兑换最大限额{{claimSituation.maxBalance}}元；每日最多可兑5次；</div>
      <div>- 如有疑问请联系客服；</div>
    </div>

    <div class="exchange-record">
      <span @click="toExchangeRecord">兑换记录</span>
    </div>

    <!-- 可领红包区域 -->
    <div class="red-packet-section">
      <div class="section-header">
        <h3 class="pageFlex" showLine="true" bgColor="var(--depYelColor)">
          可领零钱
        </h3>
        <span style="font-size: 12px; color: #999;">本月剩余可领金额{{ claimSituation.toMonthRemainingAmount }}；本日剩余可领金额{{ claimSituation.toDayRemainingAmount }}</span>
      </div>

      <!-- <div v-if="negativeStatusAmount >= 999" class="max-limit-tip">
        <i class="iconfont icon-warning"></i>
        <span>今日已领红包999元，无法再领取！</span>
      </div> -->

      <div class="red-packet-list">
        <div :class="['red-packet-item', { 'disabled': item.status === 2 }]" v-for="(item, index) in redPacketList.slice(0, 5)" :key="index">
          <span v-if="item.status === 3" class="order-no">订单号: {{ item.no }}</span>
          <div class="packet-header">
            <div :class="['packet-icon', `icon-bg`]">
              <img :src="require('@/assets/redPacket.png')" alt="红包" />
            </div>
            <div class="packet-info">
              <span class="packet-name">零钱</span>
            </div>
          </div>
          <div class="packet-content">
            <div class="packet-details">
              <div class="detail-item">
                <span class="label">零钱金额</span>
                <span class="value money">￥{{ item.amount }}</span>
              </div>
              <div class="detail-item">
                <span class="label">消耗权益</span>
                <span class="value">{{ item.consumePoint }}</span>
                <!-- <span>分</span>tp -->
              </div>
            </div>
            <button :class="['exchange-btn', { 'pending': item.status === 3 }]" @click="openConfirmDialog(item)" :disabled="item.status !== 0">{{ getButtonText(item.status) }}</button>
          </div>
        </div>
      </div>
    </div>

    <van-dialog
      v-model="showNameDialog"
      title="兑换确认"
      :before-close="handleBeforeClose"
      @confirm="claimHandle()"
      show-cancel-button
      :lazy-render="false"
    >
      <div class="flex-align withdraw">
        <van-field v-model="weChatName" class="custom-placeholder" autofocus placeholder="请填写您的姓名" />
        <div style="font-size: 14px; text-align: center; width: 90%; padding: 0 5% 8px;">
          {{ '确定消耗 ' + useItem.consumePoint + ' 权益积分兑换 ' + toFixed(useItem.amount) +' 微信零钱吗？' }}
          （请确保输入的姓名与当前微信实名一致，若不一致将无法收取零钱）
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { getCouponsByIdApi } from "api/user";
import { getWeChatPointsApi, claimWechatPointsApi, getWechatPointsRuleAndClaimActualityApi } from "api/onLine";

export default {
  name: 'PointsIndex',
  data() {
    return {
      couponsId: '', // 卡券ID
      coupon: {
        couponsMouldShowName: '我的卡券',
        couponsBalance: '0',
        couponsDeno: '0',
        couponsEndDate: '-'
      },
      redPacketList: [],
      // 统计 status = -1 的红包总金额
      negativeStatusAmount: 0,
      weChatName: '',
      showNameDialog: false,
      useItem: {},
      claimSituation: {
        //每月最大限额
        monthlyLimit: 0,
        //每日最大限额
        dailyLimit: 0,
        //单笔最小金额
        minBalance: 0,
        //单笔最大金额
        maxBalance: 0,
        //今日已兑换金额
        toDayRemainingAmount: 0,
        //本月已兑换金额
        toMonthRemainingAmount: 0,
      }
    };
  },
  mounted() {
    this.weChatName = localStorage.getItem('form:weChatName') || '';
    this.$store.commit('setPageLoading', false);
    this.setCouponId();
    // 获取路由参数 couponsId
    this.getCouponsInfo();
    // 获取红包列表数据
    this.getRedPacketList();
    // 获取微信零钱兑换规则和兑换情况
    this.getWechatPointsRuleAndClaimActuality()
  },
  methods: {
    async getWechatPointsRuleAndClaimActuality(){
      const { status, message, data } = await getWechatPointsRuleAndClaimActualityApi()
      if(status == 200){
        this.claimSituation = data
      }else{
        alert(message);
      }
    },
    async claimHandle() {
      if(this.weChatName == undefined || this.weChatName.trim() == ''){
        alert("姓名不能为空!");
        return false;
      }
      localStorage.setItem('form:weChatName', this.weChatName);
      this.showNameDialog = false
      // let res = await this.dialogHandle('提示','确定消耗' + this.amount + ' 权益积分兑换 ' + packet +' 微信零钱吗？')
      // if(!res) return

      let params = {
        couponId: this.couponsId,
        productNo: '1288',
        amount: this.useItem.consumePoint,
        weChatName: this.weChatName
      }
      this.$loading("兑换中...");
      const { status, message } = await claimWechatPointsApi(params)
      this.$clear();
      if(status == 200){
        this.$successSync('兑换成功', () => {
          this.toExchangeRecord()
          // this.$push({ path: "/coupons" });
        });
      }else{
        alert(message);
      }
    },
    handleBeforeClose(action, done) {
      if (action === 'confirm') {
        // 阻止默认关闭，由 handleConfirm 决定是否关闭
        done(false);
      } else {
        done(); // 点击取消正常关闭
      }
    },
    onClickLeft() {
      // 返回上一页，如果没有上一页则跳转到首页
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.push('/');
      }
    },
    setCouponId() {
      // 从路由参数获取 couponsId，如果没有则使用写死的值
      const queryCouponsId = this.$route.query.id;
      if (queryCouponsId) {
        this.couponsId = queryCouponsId;
      }
    },
    async getCouponsInfo() {
      const res = await getCouponsByIdApi(this.couponsId)
      if (res.status === 200) {
        this.coupon = res.data
      }
    },
    getButtonText(status) {
      switch (status) {
        case 0:
          return '兑换';
        case 2:
          return '已兑换';
        case 3:
          return '兑换中';
        default:
          return '兑换';
      }
    },
    async getRedPacketList() {
      try {
        const res = await getWeChatPointsApi(this.couponsId);
        console.log('红包列表数据:', res);
        
        if (res && (res.status === 200 || res.status === 0)) {
          const allData = res.data || [];
          
          // 统计 status = -1 的记录的 amount 值
          this.negativeStatusAmount = allData
            .filter(item => item.status != 0)
            .reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);
          
          // 过滤掉 status = -1 的记录，不放入 redPacketList
          this.redPacketList = allData.filter(item => item.status !== -1);
          
          // 将 status = 3 的数据置顶
          this.redPacketList.sort((a, b) => {
            if (a.status === 3 && b.status !== 3) return -1;
            if (a.status !== 3 && b.status === 3) return 1;
            return 0;
          });
        } else if (res.status === 400) {
          this.$error(res && res.message || '获取红包列表失败');
        }
      } catch (error) {
        console.error('获取红包列表失败:', error);
      }
    },
    openConfirmDialog(item) {
      this.useItem = item
      this.showNameDialog = true
    },
    toExchangeRecord() {
      this.$router.push({ path: "/orders?type=-1" });
    },
    toFixed(amount){
      amount = amount ?? 0
      const str = amount.toString();
      const dotIndex = str.indexOf('.');
      if (dotIndex === -1 || str.slice(dotIndex + 1).length <= 2) {
        return Number(str);
      }
      return Number(str.slice(0, dotIndex + 3));
    },
  }
};
</script>

<style scoped lang="less">
.points-index {
  min-height: 100vh;
  background-color: var(--bgColor);
  padding-bottom: 10vh;
  
  .header {
    padding: 2px 5px;
    display: flex;
    align-items: center;
    
    .btn-back {
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: transparent;
      border: none;
      font-size: 24px;
      color: #333;
      cursor: pointer;
      
      &:hover {
        opacity: 0.7;
      }
      
      &:active {
        opacity: 0.5;
      }
    }
  }
}

.points-card {
  position: relative;
  margin: 15px;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0px 5px 20px rgba(102, 51, 153, 0.3);
  
  .card-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, #10B981 0%, #059669 50%, #047857 100%);
    
    &::after {
      content: '';
      position: absolute;
      top: -30%;
      right: -20%;
      width: 120px;
      height: 120px;
      background: rgba(255, 255, 255, 0.15);
      border-radius: 50%;
    }
  }
  
  .card-content {
    position: relative;
    z-index: 1;
    padding: 20px;
    color: #fff;
  }
  
  .card-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 15px;
    
    .tag {
      display: flex;
      align-items: center;
      gap: 4px;
      background: rgba(255, 255, 255, 0.2);
      padding: 4px 12px;
      border-radius: 20px;
      font-size: 12px;
      
      &::before {
        content: '';
        width: 8px;
        height: 8px;
        background: #FFD700;
        border-radius: 50%;
      }
    }
    
    .status {
      background: rgba(255, 255, 255, 0.25);
      padding: 4px 12px;
      border-radius: 20px;
      font-size: 12px;
    }
  }
  
  .points-amount {
    display: flex;
    align-items: baseline;
    margin-bottom: 20px;
    
    .amount {
      font-size: 48px;
      font-weight: 700;
      line-height: 1;
    }
    
    .unit {
      font-size: 20px;
      margin-left: 5px;
      opacity: 0.9;
    }
  }
  
  .card-info {
    display: flex;
    justify-content: space-between;
    padding-top: 15px;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
    
    .info-item {
      display: flex;
      align-items: center;
      gap: 5px;
      font-size: 12px;
      opacity: 0.9;
      
      i {
        font-size: 14px;
      }
    }
  }
}
.max-limit-tip {
    gap: 8px;
    background: #FFF7E6;
    border: 1px solid #FFE082;
    border-radius: 8px;
    padding: 10px 15px;
    margin-bottom: 12px;
    font-size: 13px;
    color: #E65C00;
    margin: 16px;
    
    i {
      font-size: 16px;
    }
  }
  
.red-packet-section {
  padding: 0 15px;
  
  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 0 0 0;
    
    h3 {
      font-size: 14px;
      font-weight: 600;
    }
    
    .count {
      font-size: 12px;
      color: #999;
    }
  }
  
}

.red-packet-list {
  background: #F8F9FA;
  border-radius: 12px;
  padding: 12px;
  margin-bottom: 10vh;
}

.red-packet-item {
  background: #fff;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 12px;
  position: relative;
  
  &:last-child {
    margin-bottom: 0;
  }
  
  &.disabled {
    opacity: 0.5;
    
    .packet-icon {
      background: #E0E0E0 !important;
      
      img {
        filter: grayscale(100%);
      }
    }
    
    .exchange-btn {
      background: #E0E0E0 !important;
      color: #999;
      cursor: not-allowed;
    }
  }
  
  .order-no {
    position: absolute;
    top: 8px;
    right: 10px;
    font-size: 11px;
    color: #666;
    background: #f5f5f5;
    padding: 2px 8px;
    border-radius: 4px;
  }
  
  .packet-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 10px;
    
    .packet-icon {
      width: 35px;
      height: 35px;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      
      img {
        width: 22px;
        height: 22px;
      }
      
      &.icon-bg {
        background: linear-gradient(135deg, rgba(255, 107, 107, 0.5) 0%, rgba(255, 142, 83, 0.5) 100%);
      }
    }
    
    .packet-info {
      flex: 1;
      
      .packet-name {
        font-size: 15px;
        font-weight: 600;
        color: #333;
        display: block;
        margin-bottom: 6px;
      }
      
      .tags {
        display: flex;
        align-items: center;
        gap: 6px;
        
        .tag {
          font-size: 10px;
          padding: 2px 6px;
          border-radius: 4px;
          font-weight: 500;
          
          &.recommend {
            background: linear-gradient(135deg, #FF6B6B 0%, #FF8E53 100%);
            color: #fff;
          }
          
          &.limit {
            color: #999;
          }
        }
        
        .dot {
          width: 3px;
          height: 3px;
          background: #E0E0E0;
          border-radius: 50%;
        }
      }
    }
  }
  
  .packet-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 5px;
    border-top: 1px solid #F0F0F0;
    margin-top: 8px;
    
    .packet-details {
      .detail-item {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 8px;
        
        &:last-child {
          margin-bottom: 0;
        }
        
        .label {
          font-size: 12px;
          color: #999;
        }
        
        .value {
          font-size: 14px;
          font-weight: bold;
          color: #2563eb;
          
          &.money {
            color: #FF3B30;
            font-weight: 700;
            font-size: 18px;
          }
        }
      }
    }
    
    .exchange-btn {
      background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%);
      color: #fff;
      border: none;
      padding: 8px 20px;
      border-radius: 6px;
      font-size: 13px;
      font-weight: 500;
      cursor: pointer;
      
      &:active {
        opacity: 0.85;
      }
      
      &.pending {
        background: #F5F5F5;
        color: #FFB800;
        cursor: not-allowed;
        border: 1px solid #FFE082;
      }
    }
  }
}
.exchange-record {
  margin: 0 14px;
    text-align: right;
    font-size: 14px;
    color: #2B6CEE;
}

/deep/ .van-field__control {
  padding-left: 10px;
}
</style>
